import axios from "axios";

const api = axios.create({

  // <-- Your backend URL
  baseURL: "https://interviewnotebook.com/api",
   withCredentials: true

  
});

// Add JWT token to headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
